import { Link } from 'react-router-dom';

export default function Header({ title = 'Patrick Sanchez', subtitle, logo = '/logo.svg' }) {
  return (
    <header className="bg-white border-b border-secondary-200">
      <div className="container mx-auto px-4 py-4">
        <Link to="/" className="flex items-center gap-4">
          <img src={logo} alt="Logo" className="h-12 w-12 object-contain" />
          <div>
            <h1 className="text-xl font-bold text-secondary-900">{title}</h1>
            {subtitle && <p className="text-sm text-secondary-600">{subtitle}</p>}
          </div>
        </Link>
      </div>
    </header>
  );
}
